import { useTranslation } from "react-i18next";
import Layout from "../../../Components/TopNav/Topnav";
import { partnerDoctorFaqPageSrc } from "../../../util/constants";
import { resolveAppLanguage } from "../../../util/functions";
import "./partnerDoctorFaq.css";

const PAGES = [1, 2, 3];

function PartnerDoctorFaq() {
  const { t, i18n } = useTranslation();
  const lang = resolveAppLanguage(i18n);

  return (
    <Layout isProfile>
      <div className="learning_container partner-doctor-faq-wrapper">
        {PAGES.map((page) => (
          <img
            key={page}
            src={partnerDoctorFaqPageSrc(lang, page)}
            alt={`${t("faq-article-page-title")} – ${t("faq-article-page-alt", { page, count: PAGES.length })}`}
            className="partner-doctor-faq-image"
            loading={page === 1 ? "eager" : "lazy"}
            decoding="async"
          />
        ))}
      </div>
    </Layout>
  );
}

export default PartnerDoctorFaq;
